import { useEffect, useRef } from "react";

export const useOutsideClick = (callback: () => void) => {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClick = (event: { target: any }) => {
			if (ref.current && !ref?.current?.contains(event.target)) {
				callback();
			}
		};

		document.addEventListener("click", handleClick, true);

		return () => {
			document.removeEventListener("click", handleClick, true);
		};
	}, [callback]);

	return ref;
};
